<template>
  <!-- 外层容器 -->
  <div class="w-full h-auto py-[2.5vw] bg-white">
    <!-- 容器区域 -->
    <div
      class="relative w-[61.46vw] h-auto mx-auto gap-[1.3vw] flex flex-row items-start"
    >
      <!-- 左侧容器 -->
      <div class="min-w-[43.71vw] min-h-0 border border-[#EEEEEE]">
        <!-- 循环渲染每一条新闻项 -->
        <div
          v-for="(item, index) in newsList"
          :key="item.id"
          class="news-item w-auto h-auto p-[1.04vw] flex flex-col"
        >
          <div class="w-full h-full flex flex-row gap-[1.04vw]">
            <!-- 图片容器 -->
            <div
              class="w-[14.1vw] h-[8.13vw] flex flex-start items-center flex-shrink-0"
            >
              <img
                :src="item.image"
                class="w-full h-full object-center object-cover rounded-l"
                alt="news image"
              />
            </div>
            <!-- 信息容器 -->
            <div
              class="w-full h-auto flex flex-col justify-between items-start"
            >
              <!-- 文字内容 -->
              <div class="flex flex-col gap-[0.52vw]">
                <div class="flex justify-start items-center">
                  <!-- todo: 替换标签<a>中的href.link 为新闻详情页 -->
                  <div
                    class="text-[1.04vw] text-[#1A2233] font-harmony font-normal hover:text-[#05358C] cursor-pointer transition-colors duration-200"
                    @click="navigateToDetail(item.documentId)"
                  >
                    {{ truncateTitle(item.title) }}
                  </div>
                </div>
                <div class="flex justify-start items-center">
                  <div
                    class="text-[0.73vw] text-[#676B73] font-harmony font-normal"
                  >
                    {{ truncateContent(item.content) }}
                  </div>
                </div>
              </div>
              <!-- 日期容器 -->
              <div class="flex items-center gap-[0.21vw] relative">
                <i class="el-icon-date text-[0.73vw] text-[#05358C]"></i>
                <div
                  class="flex justify-center items-center text-[0.73vw] text-[#9CA3AF] font-harmony font-normal"
                >
                  {{ item.date | formatZhDate }}
                </div>
              </div>
            </div>
          </div>
          <!-- 虚线分隔 -->
          <div
            v-if="index < newsList.length - 1"
            class="relative w-full border-b border-dashed border-[#b3b3b3] h-[0.05vw] top-[1.04vw]"
          ></div>
        </div>

        <!-- 分页组件 -->
        <!-- current-page:绑定当前页码 -->
        <!-- page-sizes:每页显示条数的可选列表  目前设置5,10，防止base64过多性能过低 -->
        <!-- page-size:初始每页显示条数 -->
        <!-- total:数据总量 -->
        <!-- layout:控制分页组件的布局和功能模块 -->
        <div
          class="w-full mt-[2.08vw] px-[1.25vw] py-[0.83vw] custom-pagination"
        >
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[5, 10]"
            :page-size="pageSize"
            :total="total"
            layout="total, sizes, prev, pager, next"
          />
        </div>
      </div>
      <!-- 右侧容器：使用公共组件 -->
      <NewsSidebar :selectedCategory="selectedCategory" :rightShowNews="rightShowNews"/>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import NewsSidebar from "@/components/NewsSidebar/NewsSidebar.vue";
import {listNewsAll} from "@/api/newsInfo";

// 分类标识映射关系
const categoryMap = {
  company: "company_公司新闻",
  join: "join_加盟动态",
  industry: "industry_行业资讯",
};

export default {
  name: "news-module2",
  components: {
    NewsSidebar,
  },
  activated() {
    // 缓存激活时恢复滚动位置
    const savedY = localStorage.getItem("newsScrollY");
    if (savedY) {
      window.scrollTo({ top: parseInt(savedY) });
      localStorage.removeItem("newsScrollY");
    }
  },
  beforeRouteLeave(to, from, next) {
    // 记录当前滚动位置
    localStorage.setItem("newsScrollY", window.scrollY);
    next();
  },
  data() {
    return {
      // 分页组件
      currentPage: 1,
      pageSize: 5,
      total: 0,
      // 模拟新闻数据，后续通过接口或数据库动态获取
      newsList: [],
      hotList: [],
      // 当前选中的新闻类别，默认显示全部新闻
      selectedCategory: "",
        rightShowNews:[]
    };
  },
  created() {
    // 获取路由参数中的 category，初始化时转换分类参数
    const routeCategory = this.$route.query.category;
    this.selectedCategory = routeCategory
      ? categoryMap[routeCategory] || ""
      : "";
    // 在此处调用接口获取新闻数据
    this.fetchNewsList();
  },
  methods: {
    // 截取文本，超过一定字符时用 "..." 代替
    truncateTitle(title) {
      const maxLength = 48;
      return title.length > maxLength
        ? title.slice(0, maxLength) + "..."
        : title;
    },
    truncateContent(content) {
      const maxLength = 70;
      return content.length > maxLength
        ? content.slice(0, maxLength) + "..."
        : content;
    },
    // 分页组件的回调函数
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.fetchNewsList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchNewsList();
    },
    // 新增导航方法
    navigateToDetail(documentId) {
      this.$router.push({
        path: `/News/info/${documentId}`,
      });
    },

    // 从接口获取新闻数据
    async fetchNewsList() {
      try {
        // const baseUrl = "/api";
        // 注意：Strapi 的分页是基于 0 索引的，所以 start 要减去 1
        // const start = (this.currentPage - 1) * this.pageSize;

        // 类别过滤参数
        // let categoryFilter = "";
        // if (this.selectedCategory) {
        //   // Strapi 过滤参数，注意编码问题，如果必要可使用 encodeURIComponent
        //   categoryFilter = `&filters[news_category][$eq]=${this.selectedCategory}`;
        // }
        // // 状态过滤参数，只查询"publish_发布"的数据
        // const statusFilter = `&filters[news_status][$eq]=publish_发布`;

        // 拼接 URL 向 Strapi 接口发起 GET 请求，获取新闻列表数据
        // populate=*：关联查询相关模型的数据；
        // pagination[start]：从第几条数据开始查询；pagination[limit]：每页返回的数据条数；
        // sort：指定返回数据的排序方式；
        // const response = await axios.get(
        //   `${baseUrl}/newsinfos?populate=*&pagination[start]=${start}&pagination[limit]=${this.pageSize}&sort=publishedAt:desc${categoryFilter}${statusFilter}`
        // );
        const response = await listNewsAll(this.currentPage,this.pageSize,this.selectedCategory);
          // console.log(this.selectedCategory)
        // if(this.selectedCategory === ''){
            // console.log(response.data.records)
            if(response.data.records.length>3){
                this.rightShowNews = response.data.records.slice(0,4);
            }else {
                this.rightShowNews = response.data.records;
            }
        // }
        // console.log(response);

        // 过滤后的总数用于分页组件
        this.total = response.data.total;

        // 将数据映射为前端需要的格式
        this.newsList = response.data.records.map((item) => {
          // const imageData = item.news_cover_image;
          // const imageUrl = `${baseUrl}${
          //   imageData?.formats?.medium?.url || imageData?.url || ""
          // }`;

          return {
            documentId: item.id,
            image: item.photoContent,
            title: item.newsTitle,
            content: this.stripMarkdown(item.newsContent),
            date: item.publishedAt,
            link: `/News/info/${item.id}`,
          };
        });
      } catch (error) {
        console.error("获取新闻列表失败", error);
        this.newsList = [];
      }
    },

    // 处理Markdown内容，注意未匹配序号方法
    stripMarkdown(content) {
      if (!content) return "";
      const processedContent = content
        // 移除Markdown图片语法：![alt](url)
        .replace(/!\[.*?\]\(.*?\)/g, "")
        // 移除Markdown链接语法：[text](url)，保留链接文字
        .replace(/\[(.*?)\]\(.*?\)/g, "$1")
        // 移除加粗语法：​**text**​ 或 __text__，保留加粗内容
        .replace(/\*\*(.*?)\*\*/g, "$1")
        .replace(/__(.*?)__/g, "$1")
        // 移除斜体语法：*text* 或 _text_，保留斜体内容
        .replace(/\*(.*?)\*/g, "$1")
        .replace(/_(.*?)_/g, "$1")
        // 移除下划线语法：<u>text</u>，保留内容
        .replace(/<u>(.*?)<\/u>/g, "$1")
        // 移除删除线语法：~~text~~，保留内容
        .replace(/~~(.*?)~~/g, "$1")
        // 移除标题语法：# 标题 到 #### 四级标题
        .replace(/^#{1,4}\s+/gm, "")
        // 移除换行符语法：br&BR 或 \n
        .replace(/<\/?br\s*\/?>/gi, "")
        .replace(/\n/g, "")
        // 将连续多个空格合并为单个空格
        .replace(/\s+/g, " ")
        // 移除字符串首尾的空格
        .trim();

      return processedContent;
    },
  },
  watch: {
    "$route.query.category"(newCategoryKey) {
      // 将标识转换为完整分类名称
      this.selectedCategory = newCategoryKey
        ? categoryMap[newCategoryKey] || ""
        : "";

      this.currentPage = 1;
      this.fetchNewsList();
    },
  },
};
</script>

<style scoped>
::v-deep .el-pagination {
  display: flex;
  align-items: center;
}

/* total 元素靠左 */
::v-deep .el-pagination__total {
  margin-right: auto;
}
</style>
